import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { reopenQuestionRequested } from 'features/qa/actions';

export function* reopenQuestionSaga(action: ReturnType<typeof reopenQuestionRequested>) {
  yield call(SignalingSocket.send, {
    event: 'reopenQuestion',
    data: {
      id: action.payload.id,
    },
  });
}
